export default __webpack_public_path__ + "static/media/5-sgi-home-v1.423fba32.png";